import { authAPI } from './auth_api';
const Config = require('../conf');

const pageSize = 10;

export const servicesAPI = {
  getAll,
  getById,
  addUser,
  AdminServices,
  CustomerServices,
  BillingServices,
  MeteringServices,
  InventoryServices
};

function getAll() {
  const requestOptions = { method: 'GET', headers: authAPI.authHeader() };
  return fetch(
    Config.Local().customer_url + `/api/portal/users`,
    requestOptions
  ).then(authAPI.handleResponse);
}

function getById(id) {
  const requestOptions = { method: 'GET', ...authAPI.authOptions() };
  return authAPI
    .secureFetch(
      Config.Local().customer_url + `/api/portal/users/${id}`,
      requestOptions
    )
    .then(authAPI.handleResponse);
}

function addUser(payload) {
  const requestOptions = {
    ...authAPI.authOptions(),
    method: 'POST',
    body: JSON.stringify(payload)
  };
  return authAPI
    .secureFetch(
      Config.Local().customer_url + `/api/portal/user`,
      requestOptions
    )
    .then(authAPI.handleResponse);
}

// Admin services
function AdminServices(...params) {
  if (params[0] === 'listFiles') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/folder/${params[1]}/list`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'downloadFile') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url +
          `/api/portal/folder/${params[1]}/file/${params[2]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'logActivity') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/log_activity`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getUserActivitiesByType') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url +
          `/api/portal/activities/user/${params[1]}/type/${params[2]}/${params[3]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'auditUserActivity') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/activity/user/${params[2]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'sendMail') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/mail`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getCartridge') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/cartridge_id/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getServiceStatuses') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/status/services`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getEvents') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/events?count=${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getActiveEvents') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/events/active`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getEventsByTypes') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url +
          `/api/portal/events/${params[1]}/type/${params[2]}?seconds=${params[3]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'updateEvent') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[2])
    };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/event/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getEntityState') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url +
          `/api/portal/entity/${params[1]}/${params[2]}/state`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'upsertEntityState') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[3])
    };
    return authAPI
      .secureFetch(
        Config.Local().admin_url +
          `/api/portal/entity/${params[1]}/${params[2]}/state`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getStatesByEntityType') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url +
          `/api/portal/states/entity_type/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getWeather') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url +
          `/api/portal/status/weather/hydra/${params[1]}/time/${params[2]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getPhalanxStatusEntries') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };

    return authAPI
      .secureFetch(
        Config.Local().admin_url +
          `/api/portal/phalanx/status/entries/${params[1]}?start=${params[2]}&end=${params[3]}&count=${params[4]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getPhalanxLastStatusUpdate') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url +
          `/api/portal/phalanx/${params[1]}/last_status_update`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getHydraPhalanxLastStatusEntries') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url +
          `/api/portal/hydra/${params[1]}/phalanx/status/entries`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getMatrixRefreshDate') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        `${Config.Local().admin_url}/api/portal/matrix/refresh_date/${
          params[1]
        }`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getMatrixLiveData') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        `${Config.Local().admin_url}/api/portal/matrix/live`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getOrionTypes') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/orion/types`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getOrionsByHydra') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/orions/hydra/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getOrionsByPhalanx') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/orions/phalanx/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getOrionsByLance') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/orions/lance/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getOrionsByCustomer') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/orions/customer/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'createOrion') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/orion`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'createOrionByCustomer') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/orion/customer`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getOrionRecords') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/orion/${params[1]}/records`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'addOrionRecord') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[2])
    };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/orion/ticket/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getParkingZones') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/parking_zones`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  // if (params[0] === 'getChargerSearches') {
  //   const requestOptions = { method: 'GET', ...authAPI.authOptions() };
  //   return authAPI.secureFetch(
  //     Config.Local().admin_url + `/api/portal/charger_searches`,
  //     requestOptions
  //   ).then(authAPI.handleResponse);
  // }

  // if (params[0] === 'getChargerSearch') {
  //   const requestOptions = { method: 'GET', ...authAPI.authOptions() };
  //   return authAPI.secureFetch(
  //     Config.Local().admin_url +
  //       `/api/portal/charger_search/customer/${params[1]}`,
  //     requestOptions
  //   ).then(authAPI.handleResponse);
  // }

  // if (params[0] === 'upsertChargerSearch') {
  //   const requestOptions = {
  //     ...authAPI.authOptions(),
  //     method: 'POST',
  //     body: JSON.stringify(params[1])
  //   };
  //   return authAPI.secureFetch(
  //     Config.Local().admin_url + `/api/portal/charger_search`,
  //     requestOptions
  //   ).then(authAPI.handleResponse);
  // }

  if (params[0] === 'getContract') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/contract/customer/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'createContract') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/contract/customer/${params[2]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'updateContract') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/contract/customer/${params[2]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'startContract') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify('')
    };
    return authAPI
      .secureFetch(
        Config.Local().admin_url +
          `/api/portal/contract/customer/${params[1]}/start`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getSettings') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/settings`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getDVLACheck') {
    const registration = params[1].replace(/\s/g, '');
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/dvla_check/${registration}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getReportCustomersAwaitingLances') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        `${
          Config.Local().admin_url
        }/api/portal/report/customers_awaiting_lances`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getReportDuplicateCustomers') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        `${Config.Local().admin_url}/api/portal/report/duplicate_customers`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'updateCartridgeId') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/cartridge_id`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getLocalAuthoritiesPostcodes') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        `${Config.Local().admin_url}/api/portal/local_authorities/postcodes`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getLocalAuthorityPostcodeApproval') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        `${Config.Local().admin_url}/api/portal/local_authority/postcode/${
          params[1]
        }`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getAonSurvey') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    const queryString = params[2] ? `?auth=${params[2]}` : '';

    return authAPI
      .secureFetch(
        Config.Local().admin_url +
          `/api/portal/aon_survey/${params[1]}${queryString}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getSurveys') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/surveys`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getSurvey') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/survey/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'surveyStatus') {
    const requestOptions = { method: 'GET', headers: authAPI.authHeader() };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/survey/${params[1]}/status`,
        requestOptions
      )
      .then(authAPI.handleResponseNoLogin);
  }

  if (params[0] === 'requestSurvey') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/survey/request`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'upsertSurvey') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/survey`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'updateSurvey') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[2])
    };
    return authAPI
      .secureFetch(
        Config.Local().admin_url + `/api/portal/survey/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }
}

// Customer services
function CustomerServices(...params) {
  // Get all users
  if (params[0] === 'users') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().customer_url + `/api/portal/users`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getTypes') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().customer_url + `/api/portal/customer/types`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  // Get all customer
  if (params.length === 0) {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().customer_url + `/api/portal/customers`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getById') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().customer_url + `/api/portal/customer/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getByUserId') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().customer_url +
          `/api/portal/customer/user_id/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getByLanceTagId') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().customer_url + `/api/portal/customer/lance/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getCustomerLatLons') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().customer_url + `/api/portal/customer_lat_lons`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getLanceAssignments') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().customer_url + `/api/portal/customer/lance/assignments`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'list') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    const url = `${Config.Local().customer_url}/api/portal/customers?`;
    let queryParams = '';

    const q = params[1];

    queryParams += `page=${q.page}&size=${q.size || pageSize}`;

    if (q.type) {
      queryParams += `&type=${q.type}`;
    }

    if (q.regionArr) {
      queryParams += `&regionArr=${q.regionArr}`;
    }

    if (q.orderBy) {
      queryParams += `&orderBy=${q.orderBy}`;
    }

    if (q.orderDirection) {
      queryParams += `&orderDirection=${q.orderDirection}`;
    }

    return authAPI
      .secureFetch(url + queryParams, requestOptions)
      .then(authAPI.handleResponse);
  }

  // Customer create
  if (params[0] === 'create') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url + `/api/portal/customer`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  // Customer update
  if (params[0] === 'update') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url + `/api/portal/customer/${params[2]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  // Accept terms
  if (params[0] === 'acceptTerms') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url +
          `/api/portal/customer/${params[2]}/document/${params[3]}/accept_terms`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'signup') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url + `/api/portal/customer/signup`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'invite') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify('')
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url +
          `/api/portal/customer/invite/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'activate') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[3])
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url +
          `/api/portal/customer/activate/${params[1]}/${params[2]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'deactivate') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[2])
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url +
          `/api/portal/customer/deactivate/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'register') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url + `/api/portal/customer/register`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'notifyUser') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[2])
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url + `/api/portal/user/${params[1]}/notify`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'support') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url +
          `/api/portal/customer/${params[2]}/support`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getPreferences') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().customer_url +
          `/api/portal/customer/${params[1]}/preferences`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'updatePreferences') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url +
          `/api/portal/customer/${params[2]}/preferences`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'setPushNotificationToken') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url +
          `/api/portal/user/${params[2]}/push_token`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getLanceCustomerIdsByCustomer') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().customer_url +
          `/api/portal/customer_to_lances/customer/${params[1]}?inactive=true`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'activateLance') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify({})
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url +
          `/api/portal/customer_to_lance/lance_tag_id/${params[1]}/activate`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'assignLanceToCustomer') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url +
          `/api/portal/assign_lance/${params[2]}/customer/${params[3]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'removeLanceFromCustomer') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url +
          `/api/portal/remove_lance/${params[2]}/customer/${params[3]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  // Get vehicles
  if (params[0] === 'getCustomersVehicles') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        `${Config.Local().customer_url}/api/portal/vehicles/customers`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  // Get vehicles for customer
  if (params[0] === 'getCustomerVehicles') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        `${Config.Local().customer_url}/api/portal/vehicles/customer/${
          params[1]
        }`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  // Update vehicles
  if (params[0] === 'updateVehicles') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url +
          `/api/portal/vehicles/customer/${params[2]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  // Get lances
  if (params[0] === 'getLancesToCustomers') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        `${
          Config.Local().customer_url
        }/api/portal/customer_to_lances/customer/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  // Get customer names from customer ids (need POST not GET to pass the id list)
  if (params[0] === 'getCustomerNamesFromCustomerIds') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        `${Config.Local().customer_url}/api/portal/customers/customers`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  // Get customer names from customer-to-Lance ids (need POST not GET to pass the id list)
  if (params[0] === 'getCustomerNamesFromCustomerToLances') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        `${
          Config.Local().customer_url
        }/api/portal/lance_to_customers/customers`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  // Get customer names from Lance tag ids (need POST not GET to pass the id list)
  if (params[0] === 'getCustomerNamesFromLanceTagIds') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        `${Config.Local().customer_url}/api/portal/lances/customers`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  // Get reference vehicles
  if (params[0] === 'getReferenceVehicles') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        `${Config.Local().customer_url}/api/portal/vehicles/reference`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getVehicleData') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        `${Config.Local().customer_url}/api/portal/vehicle/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  // Get external accounts
  if (params[0] === 'getExternalAccounts') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        `${Config.Local().customer_url}/api/portal/external_accounts/customer/${
          params[1]
        }`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  // Update external accounts
  if (params[0] === 'updateExternalAccounts') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url +
          `/api/portal/external_accounts/customer/${params[2]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getCustomersContracts') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().customer_url + `/api/portal/customers/contracts`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getAonHost') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().customer_url + `/api/portal/aon/customer/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'createAonHost') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[2])
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url + `/api/portal/aon/customer/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'updateAONHostFlatpeakLocation') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[2])
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url +
          `/api/portal/aon/customer/${params[1]}/flatpeak`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'upsertAonApprovalWorkflowStep') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[2])
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url +
          `/api/portal/aon_approval_workflow/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'commenceAonService') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify({})
    };
    return authAPI
      .secureFetch(
        Config.Local().customer_url +
          `/api/portal/aon/customer/${params[1]}/commence-service`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }
}

// Billing services
function BillingServices(...params) {
  // Account create
  if (params[0] === 'create') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().billing_url + `/api/portal/account`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  // Account update
  if (params[0] === 'update') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().billing_url + `/api/portal/account/${params[2]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getAccounts') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().billing_url + `/api/portal/accounts`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getAccountByCustomerId') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().billing_url +
          `/api/portal/account/customer/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getAccountSecret') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().billing_url + `/api/portal/account/${params[1]}/secret`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'setAccountPaymentMethod') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[2])
    };
    return authAPI
      .secureFetch(
        Config.Local().billing_url +
          `/api/portal/account/${params[1]}/payment_method`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  // if (params[0] === 'makePayment') {
  //   const requestOptions = {
  //     ...authAPI.authOptions(),
  //     method: 'POST',
  //     body: JSON.stringify(params[2])
  //   };
  //   return authAPI.secureFetch(
  //     Config.Local().billing_url + `/api/portal/account/${params[1]}/make_payment`,
  //     requestOptions
  //   ).then(authAPI.handleResponse);
  // }

  if (params[0] === 'getBillsByAccountId') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().billing_url + `/api/portal/bills/account/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getMonthlyBillsByAccountId') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().billing_url +
          `/api/portal/bills/account/${params[1]}/monthly`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getTariffs') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().billing_url + `/api/portal/tariffs`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getTariff') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().billing_url + `/api/portal/tariff/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'createStripeConnectAccountSession') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify({})
    };
    return authAPI
      .secureFetch(
        Config.Local().billing_url +
          `/api/portal/stripe_connect_account_session/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'onboardStripeAccount') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify({})
    };
    return authAPI
      .secureFetch(
        Config.Local().billing_url +
          `/api/portal/stripe_connect_account_onboarded/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'createAonAccount') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().billing_url + `/portal/aon/account`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'oneOffPayment') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().billing_url + `/portal/aon/account/one-off-payment`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'processOneOffPayment') {
    const requestOptions = {
      method: 'POST',
      headers: { ...authAPI.authHeader(), 'Content-Type': 'application/json' },
      body: JSON.stringify({})
    };
    return authAPI
      .secureFetch(
        Config.Local().billing_url +
          `/portal/aon/account/process-one-off-payment/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getUnpaidAccounts') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().billing_url + `/api/portal/accounts/unpaid`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getPendingBills') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().billing_url + `/api/billing/pendingbills`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getPendingLineItems') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().billing_url + `/api/billing/pendinglineitems`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getPendingSessionlets') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().billing_url + `/api/billing/pendingsessionlets`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'processBill') {
    const requestOptions = { method: 'POST', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().billing_url + `/api/billing/process/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'applyCredit') {
    const requestOptions = {
      method: 'POST',
      ...authAPI.authOptions(),
      body: JSON.stringify({ amountGBP: params[2] })
    };
    return authAPI
      .secureFetch(
        Config.Local().billing_url +
          `/api/account/customer/${params[1]}/add-credit`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'applyLowTariff') {
    const requestOptions = {
      method: 'POST',
      ...authAPI.authOptions()
    };
    return authAPI
      .secureFetch(
        Config.Local().billing_url + `/api/billing/${params[1]}/low-tariff`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'creditEntireBill') {
    const requestOptions = {
      method: 'POST',
      ...authAPI.authOptions()
    };
    return authAPI
      .secureFetch(
        Config.Local().billing_url +
          `/api/billing/${params[1]}/credit-entire-bill`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'refreshBalances') {
    const requestOptions = {
      method: 'POST',
      ...authAPI.authOptions()
    };
    return authAPI
      .secureFetch(
        Config.Local().billing_url + `/api/billing/refresh-balances`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'recalculateBill') {
    const requestOptions = {
      method: 'POST',
      ...authAPI.authOptions()
    };
    return authAPI
      .secureFetch(
        Config.Local().billing_url + `/api/billing/${params[1]}/recalculate`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'archiveBill') {
    const requestOptions = {
      method: 'POST',
      ...authAPI.authOptions(),
      body: JSON.stringify({ archive: params[2] })
    };
    return authAPI
      .secureFetch(
        Config.Local().billing_url + `/api/billing/${params[1]}/archive`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }
}

function MeteringServices(...params) {
  if (params[0] === 'getSession') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().metering_url + `/api/portal/session/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getSessionsByPhalanx') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().metering_url +
          `/api/portal/sessions/phalanx/${params[1]}?page=${params[2]}&size=${params[3]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getSessionByLanceToCustomer') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().metering_url +
          `/api/portal/session/lance_customer/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getSessionsByLanceToCustomer') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().metering_url +
          `/api/portal/sessions/lance_customer/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getSessionsByLanceToCustomerIds') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().metering_url +
          `/api/portal/sessions/lance_customers?page=${params[2]}&size=${params[3]}&active=${params[4]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getSession') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().metering_url + `/api/portal/session/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getLatestSessionByPhalanx') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().metering_url +
          `/api/portal/session/phalanx/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getSessionletReadings') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().metering_url +
          `/api/portal/session/${params[1]}/sessionlets_readings`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getLatestSessionlet') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().metering_url +
          `/api/portal/sessionlet/session/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getSessionReadings') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().metering_url +
          `/api/portal/readings/session/${params[1]}?clear_cache=${params[2]}&axon=${params[3]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getReadings') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().metering_url +
          `/api/portal/meter/${params[1]}/readings/${params[2]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'updateSessionVehicle') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().metering_url +
          `/api/portal/session/${params[2]}/vehicle`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getMeter') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().metering_url + `/api/portal/meter/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'checkAlerts') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify('')
    };
    return authAPI
      .secureFetch(
        Config.Local().metering_url + `/api/portal/alerts`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getUnbilledSessionlets') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().metering_url + `/api/portal/sessionlets/unbilled`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getBillingSummary') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().metering_url + `/api/portal/billing/summary`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getFlatpeakBearerToken') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().metering_url + `/api/portal/flatpeak/bearer`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getFlatpeakConnectToken') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().metering_url +
          `/api/portal/flatpeak/connect?bearer_token=${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getFlatpeakLocationId') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().metering_url +
          `/api/portal/flatpeak/location_id?bearer_token=${params[1]}&connect_token=${params[2]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getFlatpeakTariff') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().metering_url +
          `/api/portal/flatpeak/tariff/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }
}

function InventoryServices(...params) {
  if (params[0] === 'getPhalanxLocationInfo') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        `${Config.Local().inventory_url}/api/portal/phalanxes/lat_lon`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getHydras') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        `${Config.Local().inventory_url}/api/portal/hydras`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getHydra') {
    if (params[1] === 'MATG99999999-9999-9999-9999-999999999999') return null;

    const refresh = params[2] ? '?refresh_cache=true' : '';
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().inventory_url +
          `/api/portal/hydra/${params[1]}${refresh}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getHydraByReference') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().inventory_url + `/api/portal/hydra/ref/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getLance') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().inventory_url + `/api/portal/lance/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getLances') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().inventory_url + `/api/portal/lances`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getLancesByCustomerId') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().inventory_url +
          `/api/portal/lances/customer_id/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  // Get lances from ids (need POST not GET to pass the id list)
  if (params[0] === 'getLancesByIds') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        `${Config.Local().inventory_url}/api/portal/lances/ids`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'updateLance') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().inventory_url + `/api/portal/lance/${params[2]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'activateLance') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify({})
    };
    return authAPI
      .secureFetch(
        Config.Local().inventory_url +
          `/api/portal/lance/${params[1]}/activate`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getHydraPhalanxes') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().inventory_url +
          `/api/portal/hydra/${params[1]}/phalanxes`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getPhalanx') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().inventory_url + `/api/portal/phalanx/${params[1]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getPhalanxByReference') {
    const refresh = params[2] ? '?refresh_cache=true' : '';
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().inventory_url +
          `/api/portal/phalanx/ref/${params[1]}${refresh}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getAllPhalanxes') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().inventory_url + `/api/portal/phalanxes`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  // Get phalanxes from ids (need POST not GET to pass the id list)
  if (params[0] === 'getPhalanxesByIds') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'POST',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        `${Config.Local().inventory_url}/api/portal/phalanxes/ids`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'getPhalanxLatLons') {
    const requestOptions = { method: 'GET', ...authAPI.authOptions() };
    return authAPI
      .secureFetch(
        Config.Local().inventory_url + `/api/portal/phalanxes/lat_lon`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'updatePhalanxByReference') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().inventory_url + `/api/portal/phalanx/ref/${params[2]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'updatePhalanxesByHydraReference') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().inventory_url +
          `/api/portal/hydra/ref/${params[2]}/phalanxes`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }

  if (params[0] === 'updateHydra') {
    const requestOptions = {
      ...authAPI.authOptions(),
      method: 'PUT',
      body: JSON.stringify(params[1])
    };
    return authAPI
      .secureFetch(
        Config.Local().inventory_url + `/api/portal/hydra/${params[2]}`,
        requestOptions
      )
      .then(authAPI.handleResponse);
  }
}

export function uploadFile(file, newFilename, folder, onProgress) {
  return new Promise((resolve, reject) => {
    const form = new FormData();
    form.append('file', file);
    form.append('newFilename', newFilename);
    form.append('folder', folder);

    const request = new XMLHttpRequest();
    request.open(
      'POST',
      Config.Local().customer_url + '/api/portal/upload/file'
    );

    const requestOptions = authAPI.authOptions();

    const headers = requestOptions.headers;
    for (const header of Object.keys(headers)) {
      if (header !== 'Content-Type')
        request.setRequestHeader(header, headers[header]);
    }
    request.withCredentials = true;

    request.addEventListener('progress', event => {
      if (onProgress) {
        onProgress(event);
      }
    });
    request.addEventListener('load', event => {
      switch (event.target.status) {
        case 300:
          reject(event);
          break;
        default:
          resolve(JSON.parse(request.response));
      }
    });
    request.addEventListener('error', event => {
      reject(event);
    });
    request.send(form);
  });
}
